@if (control$$()) {
    <mat-form-field
        [ngClass]="classHeight$$()"
        [class.show-hint]="hint$$() || hintLabel$$()"
        [class.show-error]="control$$().invalid && errorShow$$()"
        [appearance]="appearance$$()"
        [color]="color$$()"
        [floatLabel]="floatLabel$$()"
        [hideRequiredMarker]="hideRequiredMarker$$()"
        [hintLabel]="hintLabel$$()"
        [subscriptSizing]="subscriptSizing$$()">

        @if (label$$()) {
            <mat-label>{{label$$()}}:</mat-label>
        }
        <input matNativeControl #inputField id="inputField"
            (keydown.esc)="emit_esc($event)"
            [attributes]="attributes$$()"
            [autofocus]="autofocus$$()"
            [errorStateMatcher]="errorStateMatcher$$()"
            [formControl]="control$$()"
            [id]="id$$()"
            [placeholder]="placeholder$$()"
            [readonly]="readonly$$()"
            [required]="required$$()"
            [tabindex]="tabIndex$$()"
            [type]="input_type$$()"
        >
        @if (input_suffixIcon$$()) {
            <button mat-icon-button matSuffix type="button"
                (click)="emit_suffixClick($event)"
                [attr.aria-label]="input_suffixTooltip$$()"
                [disabled]="control$$().disabled"
                [matTooltip]="input_suffixTooltip$$() ?? ''"
            >
                <mat-icon>{{ input_suffixIcon$$() }}</mat-icon>
            </button>
        }
        @if (!!hint$$()) {
            <mat-hint [align]="hintAlign$$()">{{hint$$()}}</mat-hint>
        }
        @if (control$$().invalid && errorShow$$()) {
            <mat-error>{{errorMessage_getFirst()}}</mat-error>
        }
    </mat-form-field>
}
